export default "https://c.travel-assets.com/partner-portal/settings.8f6a40cd0b2a.svg";